import React from 'react';
import './how_it_works.less';

export default class HowItWorksDetails extends React.Component{
  constructor(props){
      super(props);

  }
  render(){
    return(
      <div className="how-it-works-details-wrap">
        <div className="how-it-works-details">
          <div className="heading">
              How AWB Works
          </div>
          <p className="intro-sec">
            {this.props.shipperObj.heading}
          </p>
          <div className="ship-a-package-title">
            Ship a Package
          </div>
          <div className="ship-a-package-wrap">
            <div className="ship-a-package-elem">
                 <div  style={{"backgroundImage": 'url("' + this.props.shipperObj.lila+ '")'}}className="shipment-img"></div>
                 <div className="ship-a-package-elem-detail">
                   <div className="role">SHIPPER</div>
                   <div className="name">Lila</div>
                 </div>
            </div>
            <div className="ship-a-package-elem">
                  <div  style={{"backgroundImage": 'url("' + this.props.shipperObj.manisha+ '")'}}className="shipment-img"></div>
                   <div className="ship-a-package-elem-detail">
                     <div className="role">CARRIER</div>
                     <div className="name">Manisha</div>
                   </div>
            </div>
            <div className="ship-a-package-elem">
                 <div  style={{"backgroundImage": 'url("' + this.props.shipperObj.lilaMom+ '")'}}className="shipment-img"></div>
                   <div className="ship-a-package-elem-detail">
                     <div className="role">RECIPIENT</div>
                     <div className="name">Lila's Mom</div>
                   </div>
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">1</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para1}
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">2</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para2}
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">3</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para3}
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">4</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para4}
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">5</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para5}
            </div>
          </div>
          <div className="request-a-package-title">
          Request an Item / Shop
          </div>
          <div className="ship-a-package-wrap">
            <div className="ship-a-package-elem">
                 <div  style={{"backgroundImage": 'url("' + this.props.shipperObj.dina+ '")'}}className="shipment-img"></div>
                 <div className="ship-a-package-elem-detail">
                   <div className="role">REQUESTER</div>
                   <div className="name">Dina</div>
                 </div>
            </div>
            <div className="ship-a-package-elem">
                  <div  style={{"backgroundImage": 'url("' + this.props.shipperObj.karim+ '")'}}className="shipment-img"></div>
                   <div className="ship-a-package-elem-detail">
                     <div className="role">CARRIER</div>
                     <div className="name">Karim</div>
                   </div>
            </div>
            <div className="ship-a-package-elem">
                 <div  style={{"backgroundImage": 'url("' + this.props.shipperObj.husb+ '")'}}className="shipment-img"></div>
                   <div className="ship-a-package-elem-detail">
                     <div className="role">RECIPIENT</div>
                     <div className="name">Dina’s Husband</div>
                   </div>
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">1</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para6}
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">2</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para7}
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">3</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para8}
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">4</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para9}
            </div>
          </div>
          <div className="steps-wrap">
            <div className="step-number">
               <div className="number">5</div>
            </div>
            <div className="step-content">
                {this.props.shipperObj.para10}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

HowItWorksDetails.propTypes = {
  shipperObj: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// app/profile/howItWorksDetailComponent.jsx